import { ComponentProps, FC, useCallback } from 'react'

import Button from 'components/features/pfm/Button/Button'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { OpenSellCryptoPaneAction } from 'components/features/rewards/rewardsPane/store/actions/paneState'

type SellCryptoButtonProps = {
  theme?: ComponentProps<typeof Button>['theme']
  style?: ComponentProps<typeof Button>['style']
  size?: ComponentProps<typeof Button>['size']
}

export const SellCryptoButton: FC<SellCryptoButtonProps> = ({
  theme,
  style,
  size,
}) => {
  const dispatch = useStoreDispatch()
  const openAutoinvestmentsPane = useCallback(() => {
    dispatch(new OpenSellCryptoPaneAction())
  }, [dispatch])

  return <Button theme={ theme } style={ style } size={ size } fullWidth onClick={ openAutoinvestmentsPane }>Sell crypto</Button>
}
